import React from "react";
import { FaAddressBook, FaPlus, FaRegArrowAltCircleLeft, FaSync, FaTrash } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { Col } from "reactstrap";
import { Link } from "react-router-dom";
import { SettingGeneralProvider } from "../../../context/settingGeneralContext";
import HeaderReusable from "../../Global/HeaderContent";
import { Badge } from "react-bootstrap";

export default function HeaderApointmentDoctor({
  isTabletOrMobile,
  title,
  getDataDoctorName,
  countAppointment,
  query,
  handleReset,
  setQuery,
  limit,
  setLimit,
  setPage,
  searchData,
  buttonRefresh,
  viewModalAdd,
  handleModalRelationPatient,
  showCustomButtonRelationPatient
}) {

  return (
    <SettingGeneralProvider>
      <HeaderApointmentDoctorContent
        isTabletOrMobile={isTabletOrMobile}
        title={title}
        getDataDoctorName={getDataDoctorName}
        query={query}
        handleReset={handleReset}
        countAppointment={countAppointment}
        setQuery={setQuery}
        limit={limit}
        setLimit={setLimit}
        setPage={setPage}
        viewModalAdd={viewModalAdd}
        buttonRefresh={buttonRefresh}
        searchData={searchData}
        handleModalRelationPatient={handleModalRelationPatient}
        showCustomButtonRelationPatient={showCustomButtonRelationPatient}
      />
    </SettingGeneralProvider>
  )
}

function HeaderApointmentDoctorContent({
  isTabletOrMobile,
  title,
  getDataDoctorName,
  countAppointment,
  query,
  setQuery,
  limit,
  setLimit,
  setPage,
  searchData,
  buttonRefresh,
  handleReset,
  viewModalAdd,
  handleModalRelationPatient,
  showCustomButtonRelationPatient
}) {
  return (
    <>
      <HeaderReusable
        title={
          <>
            List Appointment {getDataDoctorName} <Badge bg="primary" className="ms-2">{countAppointment}</Badge>
          </>
        }
        icon={FaAddressBook}
        isTabletOrMobile={false}
        query={query}
        setQuery={setQuery}
        limit={limit}
        setLimit={setLimit}
        setPage={setPage}
        showCustomButtonBack={true}
        showResetButton={true}
        searchData={searchData}
        onAdd={viewModalAdd}
        showAddButton={false}
        handleReset={handleReset}
        onRefresh={buttonRefresh}
        showRefreshButton={true}
        handleModalRelationPatient={handleModalRelationPatient}
        showCustomButtonRelationPatient={showCustomButtonRelationPatient}
      />
    </>
  )
}
